
function WhyJoin () {
    return (
        <div className="whyjoin d-flex flex-lg-row-reverse flex-column align-items-lg-start align-items-center mt-4">
            <div className="whyjoin__content w-50 ml-lg-auto pl-lg-5">
                <h3 className="text-green text-lg-left text-center"><strong>Why Join</strong></h3>
                <p className="whyjoin__desc mb-4">Are you a mom working to improve the health of your family? <br className="d-xl-block d-none"/>
                    Or maybe a fitness expert or health practitioner, <br className="d-xl-block d-none"/>
                    who wants access to science-based information <br className="d-xl-block d-none"/>
                    on important wellness topics for your clients.</p>
                <p className="whyjoin__desc">The best way to ensure you have a life of lasting vitality <br className="d-xl-block d-none"/>
                    and well-being is to get educated on the natural way to health.</p>
            </div>
            <img src="../images/home/whyjoin.png" alt="why join" className="img-fluid w-50 whyjoin__img"/>
            <style jsx>{`

                @media(min-width:1500px){
                    .whyjoin__content{
                        margin-top: 7rem;
                    }
                }

                @media (max-width:991px){
                    .whyjoin__content, .whyjoin__img{
                        width:70%!important;
                    }

                }

                @media (max-width:767px){
                    .whyjoin__img, .whyjoin__content{
                        width:100%!important;
                    }
                    .whyjoin__desc{
                        padding: 0 1rem;
                    }
                    .whyjoin__content{
                        margin-top: 0;
                    }

                }
            
            `}</style>
        </div>
    );
}

export default WhyJoin;